import cloud from "../../assets/whatIsAnHRACloud.svg"
import monitor from "../../assets/whatIsAnHRAMonitor.svg"
import screen from "../../assets/whatIsAnHRAScreen.svg"
import shadow from "../../assets/whatIsAnHRAShadow.svg"
import woman from "../../assets/whatIsAnHRAWoman.svg"

export default function WhatIsAnHRA() {
	return (
		<section id="what_is_hra">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-md-7">
						<div className="hra-illustration">
							<img src={cloud} alt="" className="hra-illustration__cloud" />
							<img src={shadow} alt="" className="hra-illustration__shadow" />
							<img src={monitor} alt="" className="hra-illustration__monitor" />
							<img src={screen} alt="" className="hra-illustration__screen" />
							<img src={woman} alt="" className="hra-illustration__woman" />
						</div>
					</div>
					<div className="col-12 col-md-5">
						<div className="hra-content">
							<h2 className="section-heading">What Is an HRA?</h2>
							<p>
								An HRA is a company-funded health benefit that reimburses employees, tax-free, for health insurance and eligible medical expenses.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}